import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar.component';
/**
 * NgModule definition for the Sidebar component.
 */
export class SidebarModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        SidebarComponent
    ],
    exports: [
        SidebarComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SidebarModule_tsickle_Closure_declarations() {
/** @type {?} */
SidebarModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SidebarModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
